import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { Icon } from '@pwc/pwc-deals-ui';

import {
  getErrorBannerState,
  hideBannerError,
} from '../../redux/errors/errorsSlice';

import styles from './BannerError.module.scss';

export const BannerError = () => {
  const dispatch = useDispatch();
  const { show, message } = useSelector(getErrorBannerState);

  function onClose() {
    dispatch(hideBannerError());
  }

  if (show) {
    return (
      <div
        className={classnames(
          styles['error-banner'],
          styles['error-banner--error']
        )}
        data-testid="error-banner"
      >
        <div className="d-flex justify-content-between">
          <div>
            <div className="d-flex">
              <Icon name="alert" className="icon-error fill" width="24" />
              <div
                className={classnames('ml-3', styles['error-banner__message'])}
              >
                {message}
              </div>
            </div>
          </div>
          <div>
            <div className={classnames(styles['close-button-container'])}>
              <button
                className={classnames('icon-button', styles['close-icon'])}
                type="button"
                onClick={onClose}
              >
                <Icon name="close" className="fill" width="18" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default BannerError;
